const PATIENT_APP_ANDROID_URL = 'https://play.google.com/store/apps/details?id=com.medable.axon.flask';
export const PATIENT_APP_NON_WEB_URLS = {
    PROD_IOS: 'https://apps.apple.com/us/app/medable/id1160464791',
    PROD_ANDROID: PATIENT_APP_ANDROID_URL,
    PROD_CN_IOS: 'https://apps.apple.com/cn/app/medable-for-china/id6744926564',
    PROD_CN_ANDROID: PATIENT_APP_ANDROID_URL,
    DEV_IOS: 'https://testflight.apple.com/join/MAApavIs',
    DEV_ANDROID: PATIENT_APP_ANDROID_URL,
    DEV_CN_IOS: 'https://apps.apple.com/cn/app/medable-for-china/id6744926564',
    DEV_CN_ANDROID: PATIENT_APP_ANDROID_URL,
    DEFAULT_IOS: 'https://itunes.apple.com/us/app/axon-prod/id1160464791?ls=1&mt=8',
    DEFAULT_ANDROID: PATIENT_APP_ANDROID_URL,
};
export const PATIENT_APP_NON_WEB_URLS_BY_ENV = {
    PROD: {
        ios: PATIENT_APP_NON_WEB_URLS.PROD_IOS,
        android: PATIENT_APP_NON_WEB_URLS.PROD_ANDROID,
    },
    PROD_CN: {
        ios: PATIENT_APP_NON_WEB_URLS.PROD_CN_IOS,
        android: PATIENT_APP_NON_WEB_URLS.PROD_CN_ANDROID,
    },
    DEV: {
        ios: PATIENT_APP_NON_WEB_URLS.DEV_IOS,
        android: PATIENT_APP_NON_WEB_URLS.DEV_ANDROID,
    },
    DEV_CN: {
        ios: PATIENT_APP_NON_WEB_URLS.DEV_CN_IOS,
        android: PATIENT_APP_NON_WEB_URLS.DEV_CN_ANDROID,
    },
    DEFAULT: {
        ios: PATIENT_APP_NON_WEB_URLS.DEFAULT_IOS,
        android: PATIENT_APP_NON_WEB_URLS.DEFAULT_ANDROID,
    },
};
